var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSouthSudan(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0225C24.8366 32.0225 32 24.859 32 16.0225C32 7.1859 24.8366 0.0224609 16 0.0224609C7.16344 0.0224609 0 7.1859 0 16.0225C0 24.859 7.16344 32.0225 16 32.0225Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7525 9.81952C28.3294 4.06384 22.6374 0.0224609 16.0007 0.0224609C11.5823 0.0224609 7.58275 1.81365 4.6875 4.70927L8.69438 9.81952H30.7525Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.73981 22.1676L4.6875 27.3358C7.58275 30.2314 11.5823 32.0226 16.0007 32.0226C22.6598 32.0226 28.3681 27.9543 30.7772 22.1676H8.73981Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.47803 11.7905V20.1963H31.4486C31.8075 18.8656 31.9997 17.4666 31.9997 16.0224C31.9997 14.5573 31.8024 13.1385 31.4334 11.7905H3.47803Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68579 4.70874C-1.56258 10.9571 -1.56258 21.0878 4.68579 27.3362C7.26786 24.7542 9.75117 22.2709 15.9995 16.0225L4.68579 4.70874Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.21242 12.0444L7.16524 14.7695L10.3607 13.7542L8.37255 16.4537L10.3254 19.1789L7.14361 18.1222L5.15536 20.8217L5.17724 17.469L1.99536 16.4122L5.19061 15.397L5.21242 12.0444Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53731"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0224609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthSudan);
export default __webpack_public_path__ + "static/media/south-sudan.56187ded.svg";
export { ForwardRef as ReactComponent };